import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { forkJoin, NEVER, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { BoardService } from '../services/sections/job/board.service';
import { BoardProposalItem } from '../models/proposal/proposal.model';
import { ProposalService } from '../services/sections/job/proposal.service';

@Injectable({
	providedIn: 'root'
})
export class BoardProposalsResolver implements Resolve<Observable<BoardProposalItem[]>> {

	constructor(
		private router: Router,
		private proposalService: ProposalService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.proposalService
			.getBoardProposals(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError((e) => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
